import React, { useState, useRef, useEffect } from 'react';
import {
  NavbarContainer,
  Logo,
  UserSection,
  UserAvatar,
  DropdownContainer,
  DropdownHeader,
  UserName,
  UserRole,
  DropdownBody,
  DropdownItem,
  DropdownFooter,
  LogoutButton,
} from './adminNavbar.styled';
import { UrbanCompassLogoBlack } from '../../../icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import ChangePasswordModal from './modals/ChangePasswordModal';
import { useUserInfo } from '../../../hooks/useUserInfo';

const AdminNavbar = ({ isCollapsed }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { userInfo, isLoading } = useUserInfo();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  return (
    <NavbarContainer isCollapsed={isCollapsed}>
      <Logo>
        <UrbanCompassLogoBlack color={'#000'} onClick={() => navigate('/')} />
      </Logo>
      <UserSection ref={dropdownRef}>
        <UserAvatar onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          {userInfo?.username?.charAt(0) || 'M'}
        </UserAvatar>
        <DropdownContainer isOpen={isDropdownOpen}>
          <DropdownHeader>
            <UserName>{isLoading ? 'Loading...' : userInfo?.username}</UserName>
            <UserRole>Admin</UserRole>
          </DropdownHeader>
          <DropdownBody>
            <DropdownItem>
              <svg fill="none" viewBox="0 0 12 12">
                <path
                  d="M6 0.75C4.75736 0.75 3.75 1.75736 3.75 3C3.75 4.24264 4.75736 5.25 6 5.25C7.24264 5.25 8.25 4.24264 8.25 3C8.25 1.75736 7.24264 0.75 6 0.75ZM2.25 3C2.25 0.928932 3.92893 -0.75 6 -0.75C8.07107 -0.75 9.75 0.928932 9.75 3C9.75 5.07107 8.07107 6.75 6 6.75C3.92893 6.75 2.25 5.07107 2.25 3ZM2.25 9.75C1.42157 9.75 0.75 10.4216 0.75 11.25V12C0.75 12.4142 0.414214 12.75 0 12.75C-0.414214 12.75 -0.75 12.4142 -0.75 12V11.25C-0.75 9.59315 0.593146 8.25 2.25 8.25H9.75C11.4069 8.25 12.75 9.59315 12.75 11.25V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V11.25C11.25 10.4216 10.5784 9.75 9.75 9.75H2.25Z"
                  fill="#464554"
                />
              </svg>
              Profile
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                setIsChangePasswordModalOpen(true);
                setIsDropdownOpen(false);
              }}
            >
              <svg fill="none" viewBox="0 0 12 15.75">
                <path
                  d="M9 7.5V4.5C9 2.84315 7.65685 1.5 6 1.5C4.34315 1.5 3 2.84315 3 4.5V7.5H9ZM10.5 7.5H12C12.4142 7.5 12.75 7.83579 12.75 8.25V14.25C12.75 14.6642 12.4142 15 12 15H0C-0.414214 15 -0.75 14.6642 -0.75 14.25V8.25C-0.75 7.83579 -0.414214 7.5 0 7.5H1.5V4.5C1.5 2.01472 3.51472 0 6 0C8.48528 0 10.5 2.01472 10.5 4.5V7.5Z"
                  fill="#464554"
                />
              </svg>
              Change Password
            </DropdownItem>
          </DropdownBody>
          <DropdownFooter>
            <LogoutButton onClick={handleLogout}>
              <svg fill="none" viewBox="0 0 13.5 13.5">
                <path
                  d="M5.25 0.75H3C1.75736 0.75 0.75 1.75736 0.75 3V10.5C0.75 11.7426 1.75736 12.75 3 12.75H5.25C5.66421 12.75 6 13.0858 6 13.5C6 13.9142 5.66421 14.25 5.25 14.25H3C0.928932 14.25 -0.75 12.5711 -0.75 10.5V3C-0.75 0.928932 0.928932 -0.75 3 -0.75H5.25C5.66421 -0.75 6 -0.414214 6 0C6 0.414214 5.66421 0.75 5.25 0.75ZM10.2803 4.71967C10.5732 4.42678 11.0481 4.42678 11.341 4.71967L13.841 7.21967C14.1339 7.51256 14.1339 7.98744 13.841 8.28033L11.341 10.7803C11.0481 11.0732 10.5732 11.0732 10.2803 10.7803C9.98744 10.4874 9.98744 10.0126 10.2803 9.71967L11.6893 8.31066H6C5.58579 8.31066 5.25 7.97487 5.25 7.56066C5.25 7.14645 5.58579 6.81066 6 6.81066H11.6893L10.2803 5.40165C9.98744 5.10876 9.98744 4.63388 10.2803 4.34099V4.71967Z"
                  fill="#BA1A1A"
                />
              </svg>
              Logout
            </LogoutButton>
          </DropdownFooter>
        </DropdownContainer>
      </UserSection>
      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
      />
    </NavbarContainer>
  );
};

export default AdminNavbar;
